<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
			<span class="h-panel-title">
				<template v-if="auxiliary">{{auxiliary.name}}</template><template v-if="auxiliaryItem">:{{auxiliaryItem.name}}</template> 科目明细账</span>
      <span class="dark4-color">提示：按 Ctrl + F 键并输入信息可以快速查找。</span>
    </div>
    <Row type="flex" :space-x="10" class="margin-right-left margin-top">
      <Cell>
        <account-date-choose v-model="accountDate"/>
      </Cell>
      <Cell class="label">辅助类别：</Cell>
      <Cell>
        <Select type="object" v-model="auxiliary" :deletable="false" style="min-width: 100px" :datas="auxiliaryType" keyName="id" titleName="name"/>
      </Cell>
      <Cell>
        <Button :disabled="!auxiliary" :loading="loading" color="primary" @click="doSearch">查询</Button>
      </Cell>
      <Cell :flex="1">

      </Cell>
    </Row>
    <Row class="h-panel-body" type="flex" :space-x="10">
      <Cell :flex="1">
        <table class="balance" v-if="auxiliary">
          <thead class="header">
          <tr>
            <td rowspan="2">科目编码</td>
            <td rowspan="2">科目名称</td>
            <td colspan="2">期初余额</td>
            <td colspan="2">本期发生额</td>
            <td colspan="2">期末余额</td>
          </tr>
          <tr>
            <td>借方</td>
            <td>贷方</td>
            <td>借方</td>
            <td>贷方</td>
            <td>借方</td>
            <td>贷方</td>
          </tr>
          </thead>
          <tbody>
          <!-- 遍历数据列表，生成表格行 -->
          <tr v-for="item in dataList" :key="item.subjecId">
            <!-- 科目编码列，根据层级设置缩进 -->
            <td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
            <!-- 科目名称列，根据层级设置缩进并添加hover效果 -->
            <td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover">{{item.name}}</span></td>
            <!-- 期初借方余额列，右对齐并格式化数字 -->
            <td align="right">{{item.beginningDebitBalance|numFormat}}</td>
            <!-- 期初贷方余额列，右对齐并格式化数字 -->
            <td align="right">{{item.beginningCreditBalance|numFormat}}</td>
            <!-- 本期借方发生额列，右对齐并格式化数字 -->
            <td align="right">{{item.currentDebitAmount|numFormat}}</td>
            <!-- 本期贷方发生额列，右对齐并格式化数字 -->
            <td align="right">{{item.currentCreditAmount|numFormat}}</td>
            <!-- 期末借方余额列，右对齐并格式化数字，负数时添加tip样式 -->
            <td :class="{tip:item.endingDebitBalance<0}" align="right">{{item.endingDebitBalance|numFormat}}</td>
            <!-- 期末贷方余额列，右对齐并格式化数字，负数时添加tip样式 -->
            <td :class="{tip:item.endingCreditBalance<0}" align="right">{{item.endingCreditBalance|numFormat}}</td>
          </tr>
          <!-- 数据列表为空时显示暂无数据提示 -->
          <tr v-if="!dataList.length">
            <td colspan="8" class="text-center padding">暂无数据</td>
          </tr>
          </tbody>
        </table>
      </Cell>
      <Cell v-width="200">
        <Tree @select="doSelect" :option="param" ref="auxiliary" filterable selectOnClick className="h-tree-theme-row-selected"></Tree>
      </Cell>
    </Row>
  </app-content>
</template>

<script>
/**
 * 核算科目明细账
 */
export default {
  name: "AuxiliaryAccountingDetail",
  data() {
    return {
      dataList: [],
      showNumPrice: false,
      loading: false,
      auxiliaryList: [],
      param: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'name',
        dataMode: 'list',
        datas: []
      },
      accountDate: null,
      // 辅助类别-部门
      auxiliary: null,
      // 辅助项目-店名
      auxiliaryItem: null,
      auxiliaryType: []
    }
  },
  methods: {
    /**
     * 加载辅助核算类型数据
     *
     * @description 从API获取会计科目分类列表数据，设置辅助核算类型选项，并默认选中第一个选项
     * @returns {void}
     */
    loadAuxiliaryType() {
      // 获取会计科目分类列表数据
      this.$api.setting.accountingCategory.list().then(({data}) => {
        this.auxiliaryType = data;
        // 如果存在数据，则默认选中第一个选项
        if (data.length) {
          this.auxiliary = data[0];
        }
      });
    },
    /**
     * 加载辅助余额列表数据
     *
     * 该函数根据辅助核算项ID和会计日期查询对应的辅助余额数据，
     * 查询过程中会显示加载状态，查询完成后更新数据列表并关闭加载状态
     */
    loadList() {
      // 检查辅助核算项是否存在，避免无效请求
      if (this.auxiliary) {
        // 设置加载状态为true，显示加载动画
        this.loading = true;
        // 调用API接口加载辅助余额数据
        this.$api.accountbook.loadAuxiliarySubjectBalance({
          accountDate: this.accountDate,
          auxiliaryId: this.auxiliary.id,
          auxiliaryItemId: this.auxiliaryItem.id,
          showNumPrice: this.showNumPrice
        }).then(({data}) => {
          // 将返回的数据赋值给数据列表
          this.dataList = data;
        }).finally(() => {
          // 无论请求成功或失败，最终都要关闭加载状态
          this.loading = false;
        });
      }

    },
    /**
     * 加载辅助列表数据
     * @description 根据辅助ID加载相关的辅助列表数据，处理数据格式并初始化相关状态
     * @returns {void}
     */
    loadAuxiliaryList() {
      // 清空数据列表
      this.dataList = [];
      // 调用API加载辅助列表数据
      this.$api.accountbook.loadAuxiliaryList({
        auxiliaryId: this.auxiliary.id
      }).then(({data}) => {
        // 格式化数据显示名称（编码+名称）
        data.forEach(val => val.name = val.code + " " + val.name);
        // 按编码进行排序
        data = data.sort((a, b) => a.code.localeCompare(b.code));
        // 设置参数中的数据源
        this.$set(this.param, "datas", data);
        // 如果存在数据，则设置默认选中项并加载列表
        if (data.length) {
          this.auxiliaryItem = data[0];
          this.loadList();
          // 在下次DOM更新后更新选择器的选中状态
          this.$nextTick(() => {
            this.$refs.auxiliary.updateSelect(this.auxiliaryItem.id);
          });
        }
      });
    },
    doSearch() {

      this.loadAuxiliaryList();
    },
    doSelect(node) {
      this.auxiliaryItem = node;
      this.loadList();
    },

  },
  mounted() {
    this.loadAuxiliaryType();
  }
}
</script>
<style scoped lang="less">
.h-panel-bar {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between; /* 让子元素两端对齐 */
  align-items: center;  /* 垂直居中对齐 */
}
.balance {
  width: 100%;
  border-collapse: collapse;

  td {
    padding: 0 8px;
    border: 1px solid #e2e2e2;
    font-size: 12px;
    height: 35px;

    &.tip {
      background-color: #FFEEEF;
    }
  }

  tbody tr:nth-child(even) {
    background-color: #f8fbf8;
  }

  tbody tr:hover {
    background-color: #F0F6FF;
  }

  .header {
    td {
      background-color: #F5F5F5;
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>